import { isEqual } from "lodash";

import {
    FilterPanelBaseFilter,
} from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type {
    IFilterPanelBaseFilterDeps,
} from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";

import type { IAdSpendChannelsFilterDto } from "../../types/leadsSearchFilters.dto";

export type AdSpendChannelsFilterDescription = {
    readonly channelShare: readonly number[];
};
export default class FindAdSpendChannelsFilter extends FilterPanelBaseFilter<
    IAdSpendChannelsFilterDto,
    AdSpendChannelsFilterDescription
> {
    constructor(deps: IFilterPanelBaseFilterDeps<IAdSpendChannelsFilterDto, AdSpendChannelsFilterDescription>) {
        super(deps);
    }

    isFilterDirty(currentValue: IAdSpendChannelsFilterDto | undefined): boolean {
        return JSON.stringify(this.initialDtoValue ?? {}) !== JSON.stringify(currentValue ?? {});
    }
}
